import { render, staticRenderFns } from "./SocialWallPostsEngagement.vue?vue&type=template&id=572d9b8b&"
import script from "./SocialWallPostsEngagement.vue?vue&type=script&lang=js&"
export * from "./SocialWallPostsEngagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports